@import 'spinners';

body.lightbox-open {
    overflow: hidden;
}

.video-embed {

    &.is-cta-button {
        @include margin-direction(right, 24);

        @include media-breakpoint-down(xl) {
            margin-right: 0;
        }
    }

    .img {
        width: 100%;
        height: 500px;
        background-size: cover;
        background-position: center;
    }

    button {
        width: 100%;
        border: none;
        outline: none;
        background: none;

        &:hover {
            .yt-play {
                opacity: .85;
            }
        }
    }

    img {
        max-width: 100%;
        margin: 0 auto;
    }

    .yt-play {
        position: absolute;
        top: 50%;
        max-height: 165px;
        max-width: 165px;
        transform: translate(-50%, -50%);
        filter: drop-shadow(0px 0px 6px rgba($black, .5));
        @include transitionFast(filter);
    }

    @include media-breakpoint-down(md) {
        .yt-play {
            max-height: 75px;
            max-width: 75px;
        }
    }
}

.video-embed-content {
    display: none;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    align-items: center;
    justify-content: center;
    z-index: 100;

    .video-overlay {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, .8);
        opacity: 0;
        transition: opacity 400ms;
    }

    &.open {
        display: flex;

        .video-overlay {
            opacity: 1;
        }
    }

    .video-inner {
        position: relative;

        .modal-spinner {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
        }

        .video-frame {
            position: relative;
            z-index: 2;

            &>div {
                text-align: right;
                @include margin-direction(bottom, 5);
            }
        }

        @include media-breakpoint-down(xl) {
            width: 95%;
            margin: 0 auto;

            iframe {
                width: 100%;
            }
        }
    }

    .close-frame {
        width: 30px;
        height: 30px;
        color: $white;
        padding: 0;
        @include transitionDefault(all);

        svg {
            @include svg-format(30px, 30px, #fff);
        }

        &:hover {
            opacity: .85;
        }

        @include focus-visible-box-shadow(0 0 0 2px rgba($white, .75));

        &.close-frame-bottom {
            width: auto;
        }
    }

}